import type { DisciplineScheduleStore } from './interfaces'

import { DisciplineScheduleEffectiveMode } from '../../enums'
import { SCHEDULE_WEEKS_COUNT, createScheduleGrid } from '../../discipline-schedule'

export const createDisciplineScheduleState = (): DisciplineScheduleStore => ({
  flow: null,
  step: null,
  grid: createScheduleGrid(),
  gridLoading: false,
  weeksCount: SCHEDULE_WEEKS_COUNT,
  selected: [],
  slotsError: false,
  startDate: '',
  effectiveMode: DisciplineScheduleEffectiveMode.Now,
  effectiveDate: null,
  pace: null,
  filters: {
    gender: [],
    special_features: [],
    premium: false,
  },
  activationRunId: null,
  doneRunIds: [],
  allocating: false,
  allocationLogs: null,
  allocationTutors: [],
  chosenLog: null,
  tutorReason: null,
  tutorSubReasons: [],
  tutorComment: '',
  reasonError: false,
  confirmed: false,
  confirmError: false,
  saving: false,
})
